import { useTheme } from '@automata/mui-theme';
import { TrackedIconButton } from '@automata/ui';
import { Box, SvgIconTypeMap, styled } from '@mui/material';
import Badge from '@mui/material/Badge';
import { OverridableComponent } from '@mui/material/OverridableComponent';

const StyledBadge = styled(Badge)`
  .MuiBadge-dot {
    position: absolute;
  }
`;

type Props = {
  'aria-label': string;
  trackLabel: string;
  icon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>> & {
    muiName: string;
  };
  onClick?: () => void;
  showBadge?: boolean;
  disabled?: boolean;
};

const IconButton = ({
  'aria-label': ariaLabel,
  trackLabel,
  icon: Icon,
  onClick,
  showBadge = false,
  disabled,
}: Props): JSX.Element => {
  const icon = <Icon aria-label={ariaLabel} color="inherit" />;
  const theme = useTheme();
  const color = disabled
    ? theme.palette.text.disabled
    : theme.palette.text.primary;

  return (
    <TrackedIconButton
      trackLabel={trackLabel}
      onClick={onClick}
      title={ariaLabel}
      disabled={disabled}
    >
      <Box color={color} fontSize={0}>
        <StyledBadge
          color="primary"
          variant="dot"
          badgeContent=""
          overlap="circular" // we may want to revisit this if more icons require badges
          invisible={!showBadge}
        >
          {icon}
        </StyledBadge>
      </Box>
    </TrackedIconButton>
  );
};

export default IconButton;
